import StatusLabel from 'components/StatusLabel'
import React from 'react'

const options = {
  ACTIVE: { color: 'green', content: 'Activo' },
  INACTIVE: { color: 'red', content: 'Inactivo' },
  VACATION: { color: 'yellow', content: 'Vacaciones' },
  SUSPENDED: { color: 'yellow', content: 'Suspendido' }
}

export default function EmployeeStatusLabel(props) {
  return (
    <StatusLabel size={'small'} {...options[props.status]} />
  )
}